import { ModalMessagerService } from './../../components/dialogs/modal-messager/modal-messager.service';
import { ModalMessage } from 'app/types/modalmessage';
import { InterruptableTimer } from 'app/model/interruptable-timer';
import { ProjectsService, ProjectListFilters, FilterDate } from './../../model/services/api-services/projects.service';
import { PrjSaveMessage } from './../../components/dialogs/project-save-dialog/project-save-entry.component';
import { ProjectConfigDialogService } from './../../components/dialogs/project-config-dialog/project-config-dialog.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';
import { EnvService } from 'app/env.service';
import { ServerService } from 'app/model/services/api-services/server.service';
import { Utils } from 'app/model/utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ProjectsComponent implements OnInit {

  private _hadSession = true;
  private _ready = false;
  private _firstList = true;
  private _filterBy: ProjectListFilters = {};
  private filterTimer = new InterruptableTimer();
  @HostBinding('class.page') isPage = true;

  public workflowFilterOn = false;
  public statusFilterOn = false;
  public _loadedList: Array<any> = [];
  public projectList: Array<any> = [];

  public get today(): string {
    return new Date().toISOString().split("T")[0]
  }

  private _fromDate: Date = new Date();
  public set fromDate(d: string) {
    this._fromDate = Utils.DateInputToStartDate(d);
    this.Refresh();
  }
  public get fromDate(): string {
    return this._fromDate.toISOString().split('T')[0];
  }
  private _fromDateOn = false;
  public set fromDateOn(fdo: boolean) {
    this._fromDateOn = fdo;
    this.Refresh();
  }
  public get fromDateOn(): boolean {
    return this._fromDateOn;
  }

  public get toDateAvailable(): boolean {
    if (this._fromDateOn === false) return false;
    return (this.fromCreated || this.fromModified) && (['created', 'modified'].indexOf(this.fromDateSel) === -1);
  }

  private _toDate: Date = new Date();
  public set toDate(d: string) {
    this._toDate = Utils.DateInputToEndDate(d);
    this.Refresh();
  }
  public get toDate(): string {
    return this._toDate.toISOString().split('T')[0];
  }

  private _fromDateSel: string = '';
  public set fromDateSel(sel: string) {
    this._fromDateSel = sel;
    this.toDateSel = (sel.indexOf('-g') > -1) ? sel.replace('-g', '-l') : sel.replace('-l', '-g');
    this.Refresh();
  }
  public get fromDateSel(): string {
    return this._fromDateSel;
  }

  public toDateSel: string = '';
  public get fromCreated(): boolean {
    return this.fromDateSel.indexOf('created') > -1;
  }
  public get fromModified(): boolean {
    return this.fromDateSel.indexOf('modified') > -1;
  }
  public toDateOn = false;

  public workflowFilter: string = '';
  public statusFilter: string = '';
  constructor(
    private server: ServerService,
    private configs: ProjectConfigDialogService,
    private projectSvc: ProjectsService,
    private cdr: ChangeDetectorRef,
    private messager: ModalMessagerService,
    private router: Router
  ) { }

  ngOnInit(): void {

    /*if (this.server.HasSession() === false) {
      // this.messager.Progress('Authenticating', false, 0, 'Project List');
      this._hadSession = false;
      window.requestAnimationFrame(() => {
        this.ngOnInit();
      })
      return;
    }*/
    this._ready = true;
    //this.messager.Progress('Loading projects', false, 0.66, 'Project List');
    this.filterTimer.Stop();
    this.List();


  }
  List(filters: ProjectListFilters = {}) {
    this.projectSvc.ListProjects(filters).then((response: any) => {
      this.messager.Progress('Loading Projects', false, 50, 'Project List');
      if (!!response && !!response.results) {
        this._loadedList = this.projectList = response.results;
        this.Refresh();
        this.ApplyFilters();

        this.messager.Progress('Projects loaded', true, 100, 'Project List');

      }
    });
  }
  AddProject() {
    this.configs.Show(undefined, (message: PrjSaveMessage) => {
      switch (message) {
        case 'saved':
          this.Reload();
          break;
      }
    });
  }
  ShowProjectConfig($project: any) {
    this.configs.Show($project, () => {
      this.Reload();
    });
  }
  OpenMap($project: any) {
    window.open('/project/' + $project, '_blank');
    // this.router.navigate(['project/'+$project])
  }
  Reload() {
    //ToDo reload project list
    this.List();

  }
  FilterChange() {
    this.Refresh();
    console.log('change');
    this._filterBy = {};
    if (this.workflowFilterOn) {
      if (this.workflowFilter !== '') {
        this._filterBy.workflow = this.workflowFilter;
      }
    }
    if (this.statusFilterOn) {
      if (this.statusFilter !== '') {
        this._filterBy.stage = this.statusFilter;
      }
    }

    if (this.fromDateOn) {
      let type: 'modified' | 'created' = 'modified';

      if (this.fromDateSel.indexOf('created') > -1) {
        type = 'created';
      }

      const parts = this.fromDateSel.split('-');

      const dateValue = Utils.DateToUnixtime(this._fromDate);

      this._filterBy.fromDate = {
        type: (type),
        comparison: (parts.length === 1) ? '=' : parts[1] as 'gt' | 'gte',
        value: dateValue
      }
    }

    if (this.toDateOn) {
      let type: 'modified' | 'created' = 'modified';

      if (this.toDateSel.indexOf('created') > -1) {
        type = 'created';
      }

      const parts = this.toDateSel.split('-');
      const dateValue = Utils.DateToUnixtime(this._toDate);
      this._filterBy.toDate = {
        type: (type),
        comparison: (parts.length === 1) ? '=' : parts[1] as 'lt' | 'lte',
        value: dateValue
      }
    }
    this.ApplyFilters();
    // this.filterTimer.Interrupt(true);

  }
  ApplyFilters() {
    const list = this._loadedList;
    this.projectList = [];
    this.Refresh();

    list.every((item: any, index: number) => {
      item.__visibility = true;
      if (!!this._filterBy.workflow && (this._filterBy.workflow !== '')) {
        const itemWorkflow = !!item.workflow_name ? item.workflow_name : '';
        if (itemWorkflow.toLowerCase().indexOf(this._filterBy.workflow.trim().toLowerCase()) === -1) {
          item.__visibility = false;
          return true;
        }
      }
      if (!!this._filterBy.stage && (this._filterBy.stage !== '')) {
        let stageName = '';
        const stages = (!!item.workflow_stages) ? item.workflow_stages : [];
        const filterStage = ('' + this._filterBy.stage).toLowerCase().trim();

        stages.every((stage: any) => {
          const itemStage = stage.name.toLowerCase();
          if ('' + stage.id === '' + item.stage) {
            stageName = itemStage.toLowerCase();
          }
          return true;
        })
        if ((stageName === '') || (filterStage !== stageName)) {
          item.__visibility = false;
          return true;
        }
      }
      this.ApplyDateFilters(item, this._filterBy.fromDate)
      this.ApplyDateFilters(item, this._filterBy.toDate);

      return true
    });
    this.projectList = list;
    this.Refresh();
    console.log(this.projectList);
  }
  Refresh() {
    this.cdr.detectChanges();
  }

  ApplyDateFilters(project: any, filter?: FilterDate) {
    if (!filter) return;
    const filterDate = filter.value;
    const by = filter.type;
    const comparison = filter.comparison;
    const dateVal = Utils.DateToNumber(Utils.UnixtimeToDate(filterDate));
    const projDateVal = Utils.DateToNumber(Utils.UnixtimeToDate(project[by]));

    switch (comparison) {
      case '=':
        if (projDateVal !== dateVal) project.__visibility = false;
        break;
      case 'gt':
        if (projDateVal <= dateVal) project.__visibility = false;
        break;
      case 'gte':
        if (projDateVal < dateVal) project.__visibility = false;
        break;
      case 'lt':
        if (projDateVal >= dateVal) project.__visibility = false;
        break;
      case 'lte':
        if (projDateVal > dateVal) project.__visibility = false;
        break;
    }
    return;
  }



}
